import React, { useState } from 'react';
import styles from './NriGuide.module.css'; 
import { ImCross } from "react-icons/im";
import { FaCheck } from "react-icons/fa";
import { VscGraphLine } from "react-icons/vsc";
import { FaHandHoldingHeart } from "react-icons/fa";
import { RiMoneyDollarCircleFill, RiMoneyRupeeCircleFill } from "react-icons/ri";
import { TbTax } from "react-icons/tb";
import { ImOffice } from "react-icons/im";
import { TiDocumentText } from "react-icons/ti";
import { MdDeveloperBoard, MdEditDocument, MdVerifiedUser } from "react-icons/md";
import { LiaPassportSolid } from "react-icons/lia";
import { FaRegIdBadge, FaAddressCard } from "react-icons/fa";
import { MdPhotoCamera } from "react-icons/md";
import { IoDocumentSharp, IoHome, IoGlobeSharp } from "react-icons/io5";
import { HiMagnifyingGlassCircle } from "react-icons/hi2";

const NriGuide = () => {
  const [activeTab, setActiveTab] = useState('why-invest');

  return (
    <>
      <div className={styles['nri-container']}>
        {/* Hero Header */}
        <header className={styles['nri-header']}>
          <div className={styles['header-contentNRI']}>
            <h1>Welcome to Property Plateau Realty's NRI Investment Guide</h1>
            <p className={styles['lead-text']}>
              Whether you're planning to buy your dream home in India, invest in high-growth real estate, 
              or reconnect with your roots—we're here to simplify every step of the journey.
            </p>
            <p className={styles['sub-text']}>
              As a trusted prop-tech real estate company, Property Plateau Realty offers personalized support, 
              legal clarity, and end-to-end solutions for NRIs worldwide.
            </p>
            <button className={`${styles['cta-button']} ${styles['pulse']}`}>Explore Investment Options</button>
          </div>
        </header>

        <nav className={styles['nri-tabs']}>
          <button 
            className={`${styles['tab-btn']} ${activeTab === 'why-invest' ? styles['active'] : ''}`}
            onClick={() => setActiveTab('why-invest')}
          >
            Why Invest
          </button>
          <button 
            className={`${styles['tab-btn']} ${activeTab === 'what-to-buy' ? styles['active'] : ''}`}
            onClick={() => setActiveTab('what-to-buy')}
          >
            What You Can Buy
          </button>
          <button 
            className={`${styles['tab-btn']} ${activeTab === 'documents' ? styles['active'] : ''}`}
            onClick={() => setActiveTab('documents')}
          >
            Documents
          </button>
          <button 
            className={`${styles['tab-btn']} ${activeTab === 'legal-financial' ? styles['active'] : ''}`}
            onClick={() => setActiveTab('legal-financial')}
          >
            Legal & Financial
          </button>
          <button 
            className={`${styles['tab-btn']} ${activeTab === 'services' ? styles['active'] : ''}`}
            onClick={() => setActiveTab('services')}
          >
            Our Services
          </button>
          <button 
            className={`${styles['tab-btn']} ${activeTab === 'locations' ? styles['active'] : ''}`}
            onClick={() => setActiveTab('locations')}
          >
            Locations
          </button>
        </nav>

        {/* Tab Content */}
        <div className={styles['tab-content']}>
          {activeTab === 'why-invest' && (
            <section className={styles['why-invest-section']}>
              <h2 className={styles['section-title']}>Why Should NRIs Invest in Indian Real Estate?</h2>
              <div className={styles['benefits-grid']}>
                <div className={styles['benefit-card']}>
                  <div className={styles['card-icon']}><VscGraphLine /></div>
                  <h3>High ROI Potential</h3>
                  <p>India's real estate market continues to grow across metros and emerging cities.</p>
                </div>
                <div className={styles['benefit-card']}>
                  <div className={styles['card-icon']}><FaHandHoldingHeart /></div>
                  <h3>Emotional Value</h3>
                  <p>A home in India keeps you connected to your heritage and loved ones.</p>
                </div>
                <div className={styles['benefit-card']}>
                  <div className={styles['card-icon']}><RiMoneyDollarCircleFill /></div>
                  <h3>Rental & Appreciation</h3>
                  <p>Earn rental income while watching your asset appreciate over time.</p>
                </div>
                <div className={styles['benefit-card']}>
                  <div className={styles['card-icon']}><TbTax /></div>
                  <h3>Tax Benefits</h3>
                  <p>NRIs enjoy various tax deductions and exemptions under Indian law.</p>
                </div>
                <div className={styles['benefit-card']}>
                  <div className={styles['card-icon']}><MdDeveloperBoard /></div>
                  <h3>Developer Discounts</h3>
                  <p>Early-bird offers and premium property options are often available to NRIs.</p>
                </div>
              </div>
            </section>
          )}

          {activeTab === 'what-to-buy' && (
            <section className={styles['what-to-buy-section']}>
              <h2 className={styles['section-title']}>What NRIs Can Buy in India?</h2>
              <div className={styles['buying-options']}>
                <div className={styles['allowed-properties']}>
                  <h3 className={styles['option-title']}><FaCheck style={{ marginRight: '8px'}} /> Allowed</h3>
                  <ul className={styles['property-list']}>
                    <li>Residential Properties</li>
                    <li>Commercial Properties</li>
                  </ul>
                </div>
                <div className={styles['restricted-properties']}>
                  <h3 className={styles['option-title']}><ImCross style={{ marginRight: '8px' }} /> Not Allowed</h3>
                  <ul className={styles['property-list']}>
                    <li>Agricultural land</li>
                    <li>Plantation property</li>
                    <li>Farmhouses (unless inherited or gifted)</li>
                  </ul>
                </div>
              </div>
              <p className={styles['legal-note']}>As per Indian law (FEMA guidelines)</p>
            </section>
          )}

          {activeTab === 'documents' && (
            <section className={styles['documents-section']}>
              <h2 className={styles['section-title']}>Documents Required for NRI Property Purchase</h2>
              <div className={styles['documents-list']}>
                <div className={styles['document-item']}>
                  <div className={styles['document-icon']}><LiaPassportSolid /></div>
                  <div className={styles['document-content']}>
                    <h3>Valid Indian Passport or OCI Card</h3>
                    <p>Required for identity verification and legal ownership</p>
                  </div>
                </div>
                <div className={styles['document-item']}>
                  <div className={styles['document-icon']}><FaRegIdBadge /></div>
                  <div className={styles['document-content']}>
                    <h3>PAN Card (Permanent Account Number)</h3>
                    <p>Mandatory for all financial transactions in India</p>
                  </div>
                </div>
                <div className={styles['document-item']}>
                  <div className={styles['document-icon']}><FaAddressCard /></div>
                  <div className={styles['document-content']}>
                    <h3>Proof of Address</h3>
                    <p>Both overseas and Indian address proofs may be required</p>
                  </div>
                </div>
                <div className={styles['document-item']}>
                  <div className={styles['document-icon']}><MdPhotoCamera /></div>
                  <div className={styles['document-content']}>
                    <h3>Passport-size photographs</h3>
                    <p>Recent photographs for documentation purposes</p>
                  </div>
                </div>
                <div className={styles['document-item']}>
                  <div className={styles['document-icon']}><IoDocumentSharp /></div>
                  <div className={styles['document-content']}>
                    <h3>Power of Attorney</h3>
                    <p>If appointing a representative in India for transactions</p>
                  </div>
                </div>
              </div>
              <div className={styles['assurance-banner']}>
                <p>Don't worry—we'll help you organize and validate every document.</p>
              </div>
            </section>
          )}

          {activeTab === 'legal-financial' && (
            <section className={styles['legal-financial-section']}>
              <h2 className={styles['section-title']}>Legal & Financial Assistance</h2>
              <div className={styles['assistance-grid']}>
                <div className={styles['assistance-card']}>
                  <div className={styles['assistance-icon']}><HiMagnifyingGlassCircle /></div>
                  <h3>Title & Property Verification</h3>
                  <p>Comprehensive due diligence to ensure clear property titles</p>
                </div>
                <div className={styles['assistance-card']}>
                  <div className={styles['assistance-icon']}><MdEditDocument /></div>
                  <h3>Sale Agreement Drafting</h3>
                  <p>Legally sound contract preparation protecting your interests</p>
                </div>
                <div className={styles['assistance-card']}>
                  <div className={styles['assistance-icon']}><IoHome /></div>
                  <h3>Home Loans for NRIs</h3>
                  <p>Facilitation of loans from leading Indian banks</p>
                </div>
                <div className={styles['assistance-card']}>
                  <div className={styles['assistance-icon']}><IoGlobeSharp /></div>
                  <h3>FEMA Compliance & Repatriation</h3>
                  <p>Guidance on foreign exchange regulations and fund transfers</p>
                </div>
                <div className={styles['assistance-card']}>
                  <div className={styles['assistance-icon']}><RiMoneyRupeeCircleFill /></div>
                  <h3>Registration & Tax Advisory</h3>
                  <p>Expert advice on stamp duty, registration, and TDS matters</p>
                </div>
              </div>
            </section>
          )}

          {activeTab === 'services' && (
            <section className={styles['services-section']}>
              <h2 className={styles['section-title']}>Services We Offer to NRIs</h2>
              <div className={styles['services-grid']}>
                <div className={styles['service-cardLWU']}>
                  <div className={styles['service-icon']}><HiMagnifyingGlassCircle /></div>
                  <h3>Property Discovery</h3>
                  <p>Virtual tours, curated listings, and trusted builder partnerships</p>
                </div>
                <div className={styles['service-cardLWU']}>
                  <div className={styles['service-icon']}><TiDocumentText /></div>
                  <h3>End-to-End Documentation</h3>
                  <p>From booking to registration, we handle it all</p>
                </div>
                <div className={styles['service-cardLWU']}>
                  <div className={styles['service-icon']}><MdVerifiedUser /></div>
                  <h3>Verified & Vetted Projects</h3>
                  <p>We only recommend RERA-approved, legally clear properties</p>
                </div>
                <div className={styles['service-cardLWU']}>
                  <div className={styles['service-icon']}><ImOffice /></div>
                  <h3>Property Management</h3>
                  <p>Maintenance, rental, resale, and tax filing – even while you're overseas</p>
                </div>
                <div className={styles['service-cardLWU']}>
                  <div className={styles['service-icon']}><IoGlobeSharp /></div>
                  <h3>Dedicated NRI Desk</h3>
                  <p>A team specially trained to handle your timezone, language, and legal needs</p>
                </div>
              </div>
            </section>
          )}

          {activeTab === 'locations' && (
            <section className={styles['locations-section']}>
              <h2 className={styles['section-title']}>Popular Investment Locations We Recommend</h2>
              <div className={styles['locations-grid']}>
                <div className={styles['location-card']}>
                  <div className={`${styles['location-image']} ${styles['mumbai']}`}></div>
                  <div className={styles['location-content']}>
                    <h3>Mumbai & Pune</h3>
                    <p>Luxury condos, IT hubs, rental hotspots</p>
                  </div>
                </div>
                <div className={styles['location-card']}>
                  <div className={`${styles['location-image']} ${styles['bangalore']}`}></div>
                  <div className={styles['location-content']}>
                    <h3>Bangalore</h3>
                    <p>Tech capital, strong rental demand</p>
                  </div>
                </div>
                <div className={styles['location-card']}>
                  <div className={`${styles['location-image']} ${styles['hyderabad']}`}></div>
                  <div className={styles['location-content']}>
                    <h3>Hyderabad</h3>
                    <p>Infrastructure growth, startup-friendly</p>
                  </div>
                </div>
                <div className={styles['location-card']}>
                  <div className={`${styles['location-image']} ${styles['delhi']}`}></div>
                  <div className={styles['location-content']}>
                    <h3>Delhi NCR</h3>
                    <p>Prime plots, apartments, retail investments</p>
                  </div>
                </div>
                <div className={styles['location-card']}>
                  <div className={`${styles['location-image']} ${styles['goa']}`}></div>
                  <div className={styles['location-content']}>
                    <h3>Goa & Kerala</h3>
                    <p>Vacation homes and lifestyle retreats</p>
                  </div>
                </div>
              </div>
            </section>
          )}
        </div>

        {/* Trust Section */}
        <section className={styles['trust-section']}>
          <h2 className={styles['section-title']}>Trust Property Plateau Realty</h2>
          <div className={styles['trust-badges']}>
            <div className={styles['badge']}>100% Transparency</div>
            <div className={styles['badge']}>Secure Transactions</div>
            <div className={styles['badge']}>RERA-Compliant Properties</div>
            <div className={styles['badge']}>Personalized NRI Concierge Service</div>
            <div className={styles['badge']}>Legal & Financial Advisory In-House</div>
          </div>
        </section>

        {/* Contact Section */}
        <section className={styles['contact-section']}>
          <h2 className={styles['section-title']}>Your Indian Property Journey Starts Here</h2>
          <p className={styles['contact-subtitle']}>Let us guide you home.</p>
          <div className={`${styles['contact-card']} ${styles['floating']}`}>
            <h3>Connect with Our NRI Desk</h3>
            <div className={styles['contact-method']}>
              <span>📧</span> abhishek.pandhare@propertyplateau.com
            </div>
            <div className={styles['contact-method']}>
              <span>📞</span> +91-9156091640 (India)
            </div>
            <div className={styles['contact-method']}>
              <span>📞</span> +44 7700 19 5656 (UK)
            </div>
            <button className={styles['cta-button']}>Schedule a Consultation</button>
          </div>
        </section>
      </div>
    </>
  );
};

export default NriGuide;